import { useEffect } from 'react';
import useAppState from '../../../state/appState';
import { YouAreCovered as YouAreCoveredType, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { ClaimFormSubmitFieldValue } from '../../../types/claim-form-submit-field-value';
import { getClaimFormSubmitValue } from '../../../helpers/getClaimFormSubmitValue';
import CustomerVehicle from '../CustomerVehicle/CustomerVehicle';
import './styles.scss';
import { trackInfoEventValue } from '../../../utils/trackingWrapper';

const customerVehicleElementID = 'registrationNumber';

const YouAreCovered = ({ caption, elementId }: YouAreCoveredType) => {
    const formValues = useAppState((state) => state.formValues);
    const formConfig = useAppState((state) => state.formConfig);
    const setFormValue = useAppState((state) => state.setFormValue);
    const customerVehicle = CustomerVehicle.getValueOrDefault(formValues, customerVehicleElementID);
    const brand = customerVehicle.displayValue;
    const vehicle = stripLicencePlateFromVehicleDescription(brand);

    useEffect(() => {
        setFormValue(elementId, 'You are covered page is shown');
    }, [elementId, setFormValue]);

    if (!formConfig) {
        return <></>;
    }

    trackInfoEventValue(formConfig, 'you-are-covered-page-showed', 'true', '');

    return (
        <div className="u-spacing-stack-l you-are-covered">
            <>
                <div className="flos-grid flos-grid--span-12 visible-xs visible-sm">
                    <div className={`image-container u-spacing-stack-l`}>
                        <div className={`image mobile`} />
                    </div>
                    <div>
                        <h3>Vi dækker skaden på din {vehicle}.</h3>
                    </div>
                    <div>Du kan nu fortsætte til værkstedsvalg.</div>
                </div>
                <div className="visible-md visible-lg" style={{ marginBottom: '-5rem' }}>
                    <div className="flos-grid ">
                        <div className={`flos-grid--span-6 text`}>
                            <h3 className="flos-pageheader-subtitle u-spacing-stack-l">
                                Vi dækker skaden på din {vehicle}.
                            </h3>
                            <div>Du kan nu fortsætte til værkstedsvalg.</div>
                        </div>
                        <div className={`flos-grid--span-6 image-container`}>
                            <div className={`image desktop`} />
                        </div>
                    </div>
                </div>
            </>
        </div>
    );
};

const stripLicencePlateFromVehicleDescription = (vehicleDesc: string) => {
    let str = vehicleDesc // AY94056, TESLA Model S 90D
        ?.split(','); // ["AY94056", "TESLA Model S 90D"]

    if (str.length > 1) {
        str = str.splice(1); // ["TESLA Model S 90D"]
    }

    return str
        .join(',') // TESLA Model S 90D
        .trim();
};

YouAreCovered.ResumePage = () => <></>;

YouAreCovered.isValid = () => {
    return true;
};

YouAreCovered.getValue = (formValues: FormValues, elementId: string) => {
    return formValues[elementId];
};

YouAreCovered.getValueSubmit = (
    formValues: FormValues,
    elementId: string,
    caption: string
): ClaimFormSubmitFieldValue => {
    return getClaimFormSubmitValue('supmanwidgetcombined', elementId, caption, formValues[elementId], undefined);
};

export default YouAreCovered;
